<template>
  <ModalShell :visible="feedbackBoxBool" :z-index="1000" @close="off">
    <div class="feedback_container">
      <ModalPanel class="feedback_panel" width="680px" max-width="680px" height="480px" max-height="480px" background="transparent" border="none" shadow="var(--shadow-lg)">
        <!-- 关闭按钮 -->
        <div class="mgx_close_btn close_btn_pos" @click="off">
          <SvgAsset :content="windowCloseSvg" />
        </div>

        <div class="feedback_content_box">
          <!-- 左侧装饰与标题区 -->
          <div class="feedback_sidebar">
            <div class="feedback_sidebar_inner">
              <div class="sidebar_title" @click="isShowDebug = !isShowDebug">
                {{ $t('feedback_text') }}
              </div>

              <!-- Debug 调试工具 -->
              <div class="feedback_debug_menu" v-if="isShowDebug">
                <div class="debug_item" @click="openDev">DevTools</div>
                <div class="debug_item" @click="reload">Reload</div>
                <div class="debug_item" @click="forget">Clear Config</div>
              </div>
            </div>
          </div>

          <!-- 右侧表单区 -->
          <div class="feedback_main">
            <div class="feedback_form_item">
              <textarea v-model="feedbackText" class="feedback_textarea" maxlength="200" :placeholder="$t('content_placeholder')"></textarea>
              <div class="feedback_char_limit">{{ feedbackText.length }}/200</div>
            </div>

            <div class="feedback_form_item contact_item">
              <div class="feedback_label">
                {{ $t('tel_title') }}
                <span class="feedback_sub_label">{{ $t('tel_label') }}</span>
              </div>
              <input v-model="feedbackTel" class="feedback_input" type="text" :placeholder="$t('tel_placeholder')" maxlength="40" />
            </div>

            <div class="feedback_footer">
              <div class="mgx_action_btn" :class="{ primary: feedbackText.length > 0 }" @click="toFeedback">
                <SvgAsset class="action_icon" :content="feedbackSendSvg" />
                <span>{{ $t('submit') }}</span>
              </div>
            </div>
          </div>
        </div>
      </ModalPanel>
    </div>
  </ModalShell>
</template>

<script lang="ts">
import { ref } from 'vue'
import ModalShell from '../common/ModalShell.vue'
import ModalPanel from '../common/ModalPanel.vue'
import { Http } from '@/network/http'
import { Urls } from '@/network/urls'
import i18n from '@/languages/i18n'
import { DialogType, enableDialog } from '../cdialog/dialog'
import { DeviceManager } from '@/service/device'
import { getCurrentDevice, getDevice } from '@/profiles/selector'
import { DevicePid } from '../../define/define'
import { DriverService } from '@/service/driver/driver'
import { DriverSocketMsgType } from '@libs/types/message'
import { isElectron } from '@libs/utils/envUtils'
import { appVersion } from '../../service/env'
import SvgAsset from '../common/SvgAsset.vue'
import feedbackSendSvg from '@/assets/inline-svg/feedback-send.svg?raw'
import windowCloseSvg from '@/assets/inline-svg/window-close.svg?raw'
const { t } = i18n.global
const feedbackBoxBool = ref(false)
export { feedbackBoxBool }
</script>

<script lang="ts" setup>
const feedbackText = ref('')
const feedbackTel = ref('')

const off = () => (feedbackBoxBool.value = false)

const toFeedback = async () => {
  if (feedbackText.value.length) {
    const data = await getFeedbackParams()
    Http.post(Urls.feedback, data)
      .then((_) => {
        feedbackText.value = ''
        feedbackTel.value = ''
        enableDialog(t('submit_success'), DialogType.notice, true)
      })
      .catch((_) => {
        enableDialog(t('submit_failed'), DialogType.notice, false)
      })
  }
}

// 获取feedback的参数
const getFeedbackParams = async () => {
  const deviceListName: string[] = []
  const devices = DeviceManager.instance.state.deviceList.concat(DeviceManager.instance.state.webDeviceList)
  devices.forEach((item) => {
    const device = getDevice(item.ID)
    if (device) {
      deviceListName.push(device.name)
    }
  })
  let deviceName = ''
  if (getCurrentDevice.value) {
    deviceName = `${getCurrentDevice.value.name}`
  }
  let firmwareVersion = '未选择设备'
  if (DeviceManager.instance.state.currentPid != DevicePid.None) {
    firmwareVersion = await DriverService.instance.askDeviceVersion()
  }
  const data = {
    content: `${feedbackText.value} 
      键盘：${deviceListName.join('+')}， 当前键盘：${deviceName}，固件版本：${firmwareVersion}，UI版本：${appVersion()}，软件版本：${DeviceManager.instance.state.driverServiceVersion},  env：${isElectron() ? 'exe' : 'webhid'}`,
    contact: feedbackTel.value,
  }
  return data
}

const openDev = () => {
  if (typeof electronAPI !== 'undefined') {
    electronAPI.openDev()
  }
}
const isShowDebug = ref(false)
const reload = () => {
  window.location.reload()
}
const forget = async () => {
  DriverService.instance.askType(DriverSocketMsgType.MTForgetDevice)
  window.location.reload()
}
</script>

<style lang="less" scoped>
.feedback_container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  -webkit-app-region: no-drag;

  .feedback_panel {
    border-radius: var(--radius-l);
    position: relative;
    overflow: hidden;
    animation: feedbackFadeIn 0.4s var(--transition-base);

    .close_btn_pos {
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 10;
    }

    .feedback_content_box {
      width: 100%;
      height: 100%;
      display: flex;

      .feedback_sidebar {
        width: 200px;
        height: 100%;
        background: var(--brand-color);
        position: relative;
        flex-shrink: 0;

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: url('@/assets/img/fb.png');
          background-size: cover;
          opacity: 0.15;
          mix-blend-mode: overlay;
        }

        .feedback_sidebar_inner {
          position: relative;
          z-index: 2;
          padding: 40px 24px;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .sidebar_title {
          color: var(--color-white);
          font-size: 24px;
          font-weight: 700;
          line-height: 1.4;
          cursor: pointer;
          user-select: none;
        }

        .feedback_debug_menu {
          margin-top: auto;
          display: flex;
          flex-direction: column;
          gap: 12px;

          .debug_item {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.6);
            cursor: pointer;
            transition: var(--transition-base);

            &:hover {
              color: var(--color-white);
              text-decoration: underline;
            }
          }
        }
      }

      .feedback_main {
        flex: 1;
        padding: 50px 40px 40px 40px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        background: var(--bg-subtle);

        .feedback_form_item {
          display: flex;
          flex-direction: column;
          gap: 8px;
          position: relative;

          .feedback_textarea {
            width: 100%;
            height: 200px;
            background: var(--color-gray-1);
            border: 1px solid transparent;
            border-radius: var(--radius-s);
            padding: 16px;
            font-size: 14px;
            color: var(--color-dark);
            outline: none;
            resize: none;
            transition: var(--transition-base);

            &:focus {
              border-color: var(--brand-color-pure);
              background: var(--color-white);
              box-shadow: 0 0 0 4px rgba(var(--color-brand-2-rgb), 0.1);
            }

            &::placeholder {
              color: var(--color-text-hint);
            }
          }

          .feedback_char_limit {
            position: absolute;
            bottom: 12px;
            right: 12px;
            font-size: 12px;
            color: var(--color-text-hint);
          }

          &.contact_item {
            background: var(--color-gray-1);
            border-radius: var(--radius-s);
            padding: 12px 16px;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            border: 1px solid transparent;
            transition: var(--transition-base);

            &:focus-within {
              border-color: var(--brand-color-pure);
              background: var(--color-white);
              box-shadow: 0 0 0 4px rgba(var(--color-brand-2-rgb), 0.1);
            }

            .feedback_label {
              font-size: 13px;
              color: var(--color-dark);
              font-weight: 500;
              white-space: nowrap;

              .feedback_sub_label {
                color: var(--color-text-hint);
                font-weight: 400;
                margin-left: 4px;
              }
            }

            .feedback_input {
              flex: 1;
              background: transparent;
              border: none;
              outline: none;
              font-size: 14px;
              color: var(--color-dark);
              text-align: right;
              padding-left: 20px;

              &::placeholder {
                color: var(--color-text-hint);
              }
            }
          }
        }

        .feedback_footer {
          margin-top: auto;
          display: flex;
          justify-content: flex-end;

          .mgx_action_btn {
            padding: 0 32px;
            height: 38px;
            border-radius: var(--action-btn-radius);
            background: var(--color-gray-1);
            color: var(--color-text-hint);
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            transition: var(--transition-base);
            font-weight: 600;
            user-select: none;
            box-shadow: var(--action-btn-shadow);

            .action_icon {
              width: 18px;
              height: 18px;
              transition: var(--transition-base);

              :deep(svg) {
                width: 100%;
                height: 100%;
              }
            }

            &:hover {
              transform: translateY(-2px);
              box-shadow: var(--action-btn-shadow-hover);
            }

            &.primary {
              background: var(--brand-color);
              color: var(--color-white);
              box-shadow: var(--action-btn-primary-shadow);

              &:hover {
                box-shadow: var(--action-btn-primary-shadow-hover);

                .action_icon {
                  transform: scale(1.1) rotate(-10deg);
                }
              }
            }

            &.disabled {
              cursor: not-allowed;
              opacity: 0.6;
              transform: none !important;
            }
          }
        }
      }
    }
  }
}

@keyframes feedbackFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
